import apiClient from './client';
import { CreateOpinionSchema, UpdateOpinionSchema } from 'shared-schemas';

export const opinionsApi = {
  /**
   * List all opinions with pagination.
   */
  list: async (params = {}) => {
    const response = await apiClient.get('/api/opinions', { params });
    return response.data;
  },

  /**
   * Get a single opinion by ID.
   */
  get: async (id) => {
    const response = await apiClient.get(`/api/opinions/${id}`);
    return response.data;
  },

  /**
   * Match opinions to content keywords.
   * @param {string[]} keywords - Keywords to match
   * @param {number} maxResults - Maximum results to return
   */
  match: async (keywords, maxResults = 3) => {
    const response = await apiClient.post('/api/opinions/match', {
      keywords,
      maxResults,
    });
    return response.data;
  },

  /**
   * Get opinions related to a topic.
   */
  getRelated: async (id) => {
    const response = await apiClient.get(`/api/opinions/${id}/related`);
    return response.data;
  },

  /**
   * Create a new opinion.
   */
  create: async (opinionData) => {
    const validated = CreateOpinionSchema.parse(opinionData);
    const response = await apiClient.post('/api/opinions', validated);
    return response.data;
  },

  /**
   * Update an existing opinion.
   */
  update: async (id, opinionData) => {
    const validated = UpdateOpinionSchema.parse(opinionData);
    const response = await apiClient.patch(`/api/opinions/${id}`, validated);
    return response.data;
  },

  /**
   * Delete an opinion.
   */
  delete: async (id) => {
    await apiClient.delete(`/api/opinions/${id}`);
  },
};
